import { render, staticRenderFns } from "./gc-popup-deposit-claim.vue?vue&type=template&id=3970b8ce"
import script from "./gc-popup-deposit-claim.vue?vue&type=script&lang=js"
export * from "./gc-popup-deposit-claim.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-deposit-claim.vue?vue&type=style&index=0&id=3970b8ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports